import styled from "@emotion/styled";

export const Ul = styled.ul`
    margin-block-start: 1em;
    margin-block-end: 1em;
    padding-inline-start: 20px;
    list-style-type: disc;
    display: block;
`;
